import { EOptionSymbolSide } from '@aqx-core/common/api/market';
import { ESortType } from '@aqx-core/common/utils/sorting/types';

export interface IExpandOptionChainAndHighlightSymbolParams {
  underlyingSymbolId: string | undefined;
  expiration: string | undefined;
}

export enum EUIOptionSide {
  CALL = 'CALL',
  PUT = 'PUT',
  ALL = 'ALL'
}

export interface IUseSelectedOptionPriceListKeyParams<T> {
  expirationId: string;
  side: EOptionSymbolSide;
  sortedBy?: { key: keyof T; direction: ESortType };
}

export interface IUseSelectedOptionPriceListStrikeParams {
  expirationId: string;
  sortedBy: ESortType;
}

export interface ISelectOptionPriceListListKey {
  symbol: string;
  expiration: string;
  strikePrice: number;
}
